<template>
  <div class="tab_header" id="sticky_tabs">
    <div class="container large">
      <div class="tab_group mb-0">
        <router-link
          v-if="!iframe"
          id="experiences-router-link"
          class="tab"
          :to="'/' + $route.params.client + '/activity' + '/' + agentKey"
          activeClass="active"
          >Experiences</router-link
        >

        <router-link
          v-if="!iframe"
          class="tab"
          v-show="packages && packages.length"
          :to="'/' + $route.params.client + '/package' + '/' + agentKey"
          activeClass="active"
          >Packages</router-link
        >

        <router-link
          v-if="client.SellGiftCardsOnline && !iframe"
          class="tab"
          :to="'/' + $route.params.client + '/giftcard' + '/' + agentKey"
          activeClass="active"
          >eGift&nbsp;Card</router-link
        >
      </div>

      <cart-icon slot="cart_bar" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import CartIcon from "../components/CartIcon.vue";

export default {
  name: "TabHeader",
  computed: {
    ...mapState(["client"]),
    ...mapGetters(["packages", "clientAgentKey"]),
    iframe() {
      return localStorage.getItem("iframeModal");
    },
    agentKey() {
      return this.clientAgentKey ? this.clientAgentKey : "";
    },
  },
  components: {
    CartIcon,
  },
};
</script>

<style></style>
